export default function Paginacao({ pagina, totalPaginas, onChange }) {
  if (totalPaginas <= 1) return null;

  // com muitas páginas, mostra uma janela ao redor da atual em vez de 300 botões
  const inicio = Math.max(1, Math.min(pagina - 2, totalPaginas - 4));
  const paginas = Array.from({ length: Math.min(5, totalPaginas) }, (_, i) => inicio + i);

  return (
    <nav className="d-flex justify-content-center align-items-center gap-1 mt-3">
      <button
        type="button"
        className="wh-btn wh-btn-outline wh-btn-sm"
        disabled={pagina === 1}
        onClick={() => onChange(pagina - 1)}
      >
        <i className="bi bi-chevron-left" /> Anterior
      </button>
      {paginas.map((p) => (
        <button
          key={p}
          type="button"
          className={`wh-btn wh-btn-sm ${p === pagina ? 'wh-btn-primary' : 'wh-btn-outline'}`}
          onClick={() => onChange(p)}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        className="wh-btn wh-btn-outline wh-btn-sm"
        disabled={pagina === totalPaginas}
        onClick={() => onChange(pagina + 1)}
      >
        Próxima <i className="bi bi-chevron-right" />
      </button>
    </nav>
  );
}
